import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Radio, PenLine, Bot, FileSpreadsheet, Users, Filter,
  Map, Contact, Send, Zap, Settings, ClipboardCheck, Target, Sunrise, Banknote, Newspaper,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

export const NAV = [
  {
    group: "Operations",
    items: [
      { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
      { to: "/feed", label: "Listening Feed", icon: Radio },
      { to: "/press", label: "Local Press", icon: Newspaper },
      { to: "/money", label: "Opponent Money", icon: Banknote },
      { to: "/studio", label: "Content Studio", icon: PenLine },
      { to: "/agent", label: "Agent Console", icon: Bot },
      { to: "/briefings", label: "Morning Briefing", icon: Sunrise, roles: ["admin", "manager"] },
    ],
  },
  {
    group: "Audience",
    items: [
      { to: "/voters", label: "Voter File", icon: FileSpreadsheet, roles: ["admin", "manager"] },
      { to: "/personas", label: "Personas", icon: Users },
      { to: "/segments", label: "Segments", icon: Filter },
      { to: "/map", label: "Sentiment Map", icon: Map },
      { to: "/gotv", label: "GOTV / Turnout", icon: Target, roles: ["admin", "manager"] },
    ],
  },
  {
    group: "Outreach",
    items: [
      { to: "/contacts", label: "Contacts", icon: Contact },
      { to: "/outreach", label: "Email & Press", icon: Send },
      { to: "/canvassing", label: "Canvassing", icon: ClipboardCheck, roles: ["admin", "manager"] },
      { to: "/automations", label: "Automations", icon: Zap },
    ],
  },
  {
    group: "Admin",
    items: [{ to: "/settings", label: "Settings", icon: Settings }],
  },
];

export function NavList({ onNavigate }) {
  const { user } = useAuth();
  return (
    <nav className="flex flex-col gap-6 px-3">
      {NAV.map((section) => {
        const items = section.items.filter((i) => !i.roles || i.roles.includes(user?.role));
        if (!items.length) return null;
        return (
          <div key={section.group}>
            <p className="mb-2 px-3 text-[0.65rem] font-bold uppercase tracking-[0.18em] text-slate-400">
              {section.group}
            </p>
            <div className="flex flex-col gap-0.5">
              {items.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.end}
                    onClick={onNavigate}
                    data-testid={`sidebar-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className={({ isActive }) =>
                      cn(
                        "group flex items-center gap-3 rounded-lg border-l-2 px-3 py-2 text-sm font-medium transition-all duration-150",
                        isActive
                          ? "border-brand-red bg-brand-red/[0.07] font-semibold text-brand-red"
                          : "border-transparent text-slate-600 hover:bg-slate-50 hover:text-brand-ink"
                      )
                    }
                  >
                    <Icon className="h-[1.05rem] w-[1.05rem]" />
                    {item.label}
                  </NavLink>
                );
              })}
            </div>
          </div>
        );
      })}
    </nav>
  );
}
